import dayjs from 'dayjs';

export const formattedDateEn = (date: string) => {
  return dayjs(date).locale('en').format('dddd, D MMMM YYYY');
};

export const formattedDateEnShortAndHy = (date: string) => {
  return dayjs(date).locale('en').format('D-MMM-YYYY');
};

export const formattedDateEnShort = (date: string) => {
  return dayjs(date).locale('en').format('D MMM YYYY');
};

export const formattedDateEnDay = (date: string) => {
  const dayName = dayjs(date).format('ddd');
  const dayOfMonth = dayjs(date).format('D');

  return `${dayName} \n ${dayOfMonth}`;
};

export const stringToDate = (inputDate: string | undefined): Date | undefined => {
  try {
    if (!inputDate) {
      return undefined;
    }

    const date = new Date(inputDate);
    if (isNaN(date.getTime())) {
      return undefined;
    }

    return date;
  } catch (error) {
    return undefined;
  }
};

export const dateToString = (date: Date): string => {
  return dayjs(date).format('YYYY-MM-DD');
};

export const stringToDisplayDate = (inputDate: string | undefined): string => {
  try {
    if (!inputDate) {
      return '-';
    }

    const date = new Date(inputDate);
    if (isNaN(date.getTime())) {
      return '-';
    }

    return dayjs(date).format('DD-MMM-YYYY');
  } catch (error) {
    return '-';
  }
};
